<template>
  <div class="content-inner-wrapper">
    <div class="select_wrap">
      <div class="select_box left">
        <!-- <el-select
          v-model="filterData.jixiaoType"
          class="y-input"
          clearable
          placeholder=""
          @change="changeQuery(true)"
        >
          <el-option label="全部类型" value=""></el-option>
          <el-option
            v-for="item in performanceGroupTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
      </div>
      <div class="select_box right">
        <input
          v-model.trim="filterData.groupName"
          type="text"
          class="yioks_input"
          style="width: 160px"
          placeholder="请输入关键字"
          @keyup.enter="changeQuery(true)"
        />
        <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
      </div>
    </div>
    <div class="list_wrap">
      <div class="table" v-if="!empty && !loading">
        <div class="thead">
          <div class="tr">
            <div class="th seq">序号</div>
            <div class="th groupName">评估指标组名</div>
            <!-- <div class="th groupType">指标类型</div> -->
            <div class="th createdAt">创建时间</div>
            <div class="th info">备注</div>
            <div class="th action">操作</div>
          </div>
        </div>
        <div class="scrollArea">
          <vue-scroll>
            <div class="tbodyWrap">
              <div class="tbody">
                <div class="tr" v-for="(item, index) in performanceList" :key="item.uuid">
                  <div class="td seq"><p>{{ index + 1 }}</p></div>
                  <div class="td groupName"><p :title="item.groupName">{{ item.groupName }}</p></div>
                  <!-- <div class="td groupType"><p>{{ item.jixiaoType | groupTypeFiler }}</p></div> -->
                  <div class="td createdAt"><p>{{ item.createdAt | time }}</p></div>
                  <div class="td info"><p :title="item.remark">{{ item.remark || '--'}}</p></div>
                  <div class="td action">
                    <p>
                      <span class="item" @click="handleCheckDetails(item)">查看</span>
                      <span class="split">/</span>
                      <span class="item" @click="handleEditRow(item)">编辑</span>
                      <span class="split">/</span>
                      <span class="item" @click="handleDeleteRow(item)">删除</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div>
    </div>

    <yioks-loading v-if="loading" />
    <yioks-empty
      v-if="empty"
      tips="暂时没有数据，"
      name="立即添加评估指标组"
      @callback="handleAddPerformanceGroup"
    ></yioks-empty>

    <template v-if="isShowAddDialog">
      <group-dialog
        :isOpen="isShowAddDialog"
        :isEdit="isEditMode"
        :defaultInfo="editRow"
        @closeGroupDialog="groupDialogCallBack"
      ></group-dialog>
    </template>

    <yioks-tips :showTip="deleteFlag" tipMsg="确认删除该指标组？" :loading="repeatDelete" @callback="handleConfirmDelete"></yioks-tips>
  </div>
</template>

<script>
import { performanceGroupTypeList } from "@/assets/js/yioksSelect";
import { getPerformanceList, deletePerformanceGroup } from '@/api/performance';

export default {
  props: {
    isShowAddDialog: {
      type: Boolean,
      default: false,
      required: false,
    },
    page: {
      type: Number,
      default: 0,
      required: false,
    },
    total: {
      type: Number,
      default: 0,
      required: false,
    },
    pageSize: {
      type: Number,
      default: 0,
      required: false,
    },

  },

  watch: {
    page() {
      this.changeQuery();
    },
  },

  components: {
    'group-dialog': () => import('./PerformanceGroupDialog'),
    'yioks-tips': () => import('@/components/YioksTip')
  },

  data() {
    return {
      empty: false,
      loading: false,
      filterData: {
        jixiaoType: "",
        groupName: "",
      },
      performanceGroupTypeList,
      performanceList: [],
      isEditMode: false,
      editRow: {},
      deleteFlag: false,
      repeatDelete: false,
      deleteRow: {}
    };
  },

  filters: {
    groupTypeFiler(val) {
      let res = '--';
      switch(val) {
        case 'ORGAN':
          res = '区体育行政部门';
          break;
        case 'YOUTH':
          res = '青训中心';
          break;
        case 'CLUB':
          res = '精英机构/基地';
          break;
        case 'TRAINCAMP':
          res = '训练营';
          break;
        default:
          break;
      }
      return res;
    }
  },

  mounted() {
    this.setSearchData();
    this.changeQuery();
  },

  methods: {
    // 设置指标组添加弹窗
    handleSetAddDialog(flag) {
      this.$emit("update:isShowAddDialog", flag);
    },

    // 打开添加指标组弹窗
    handleAddPerformanceGroup() {
      this.$emit("update:isShowAddDialog", true);
    },

    // 设置页面初始值
    setSearchData() {
      const { page, jixiaoType, groupName } = this.$route.query;
      jixiaoType && this.$set(this.filterData, 'jixiaoType', jixiaoType);
      groupName && this.$set(this.filterData, 'groupName', groupName);
      page && (this.page = Number(page));
    },

    // 页面初始化
    changeQuery(flag) {
      flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.fullpath,
        query: {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
        }
      })
      this.loadPageListData();
    },

    // 加载页面列表信息
    loadPageListData() {
      this.loading = true;
      this.empty = false;
      const { groupName } = this.$route.query;
      const paramsData = {
        groupName,
        page: this.page,
        size: this.pageSize,
       };
      getPerformanceList(paramsData)
        .then(res => {
          this.loading = false;
          if(res.code) {
            this.$message.error(res.msg);
            return
          }
          // this.$emit("update:page",)
          this.$emit("update:total", res.totalElements)
          const { empty, content } = res;
          this.empty = empty
          this.performanceList = content;
        })
        .catch(err => {
          this.loading = false;
          this.empty = true
          console.error('err', err)
        })
    },

    // 查看 行 详情
    handleCheckDetails(row) {
      const { uuid } = row;
      this.$router.push({
        path: `indicator/${uuid}`,
        // query: {
        // }
      })
    },

    // 点击 行 编辑
    handleEditRow(row) {
      this.editRow = row;
      this.isEditMode = true;
      this.handleSetAddDialog(true)
    },

    // 点击 行 删除
    handleDeleteRow(row) {
      this.deleteRow = row;
      this.deleteFlag = true;
    },

    // 指标组弹窗回掉
    groupDialogCallBack(dialogStatus, okFlag) {
      if(okFlag) {
        this.changeQuery(true);
        this.handleSetAddDialog(dialogStatus)
      } else {
        // 取消操作
        this.handleSetAddDialog(false)
      }
      this.isEditMode = false;
      this.editRow = {}
    },

    // 确认删除指标组
    handleConfirmDelete(flag) {
      if(flag) {
        this.repeatDelete = true;
        const { uuid } = this.deleteRow;
        deletePerformanceGroup(uuid)
          .then(res => {
            if(res.code) {
              this.$message.error(res.msg);
              return
            }
            this.$message.success('删除成功！')
            this.deleteRow = {};
            this.repeatDelete = false;
            this.deleteFlag = false;
            this.changeQuery();
          })
          .catch(err => {
            this.repeatDelete = false;
            console.error('err', err)
          })
      } else {
        this.deleteRow = {};
        this.deleteFlag = false;
      }

    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        min-height 45px
        height: auto
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        min-height 49px
        height: auto
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height inherit
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        // white-space nowrap
        // overflow hidden
        // text-overflow ellipsis
        white-space pre-line
        padding 3px 5px
        text-align: center
        line-height: 1.4em
        color $color_white
.seq
  width 6%
.groupName
  width 24%
.createdAt
  width 14%
// .groupType
//   width 12%
.info
  width 38%
.action
  // width 16%
  flex 1
  .item
    cursor pointer
    user-select none
    color $green_color
  .split
    margin 0 5px
</style>

<style lang="stylus" >
.y-input
  input
    border-radius 0px !important
</style>
